import APP_CONSTANTS from './constants/app.constants';

export const getAssetUrl = (casePath: string, assetPath: string): string => {
  return `${APP_CONSTANTS.PATIENT_CASES_REPO_PATH}${casePath}${assetPath}`;
};
